import { Component } from '@angular/core';

@Component({
  selector: 'iss-horizontal-line',
  standalone: true,
  template: '',
  styleUrls: [ './horizontal-line.component.scss' ],
})
export class HorizontalLineComponent {}
